import { render, staticRenderFns } from "./index-cool.vue?vue&type=template&id=76fca5b4&scoped=true"
import script from "./index-cool.vue?vue&type=script&lang=js"
export * from "./index-cool.vue?vue&type=script&lang=js"
import style0 from "./index-cool.vue?vue&type=style&index=0&id=76fca5b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fca5b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fca5b4')) {
      api.createRecord('76fca5b4', component.options)
    } else {
      api.reload('76fca5b4', component.options)
    }
    module.hot.accept("./index-cool.vue?vue&type=template&id=76fca5b4&scoped=true", function () {
      api.rerender('76fca5b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header/index-cool.vue"
export default component.exports